import React from 'react';

import { Container, Title, Message } from './styled';

type AlertProps = {
  title: string;
  children: React.ReactNode;
};

export const AlertBanner: React.FC<AlertProps> = ({
  title,
  children,
  ...rest
}) => (
  <Container {...rest}>
    <Title>{title}</Title>
    <Message>{children}</Message>
  </Container>
);
